import { DataHistory, DataModel } from '@shared/models/data-model';
import { baseFeatureId } from '@/app/constants';
import { FeatureAuthorizationType } from '@/app/platform/platform-data/models/feature-authorization-type';
import { PageFeature } from '@ervo/page-framework';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';

/**
 * The link between a Feature (configured in routes) and a NavigationItem.
 */
export class FeatureAuthorizationEntity extends DataModel {
  constructor(
    id: string,
    meta: Partial<DataHistory>,
    public navigationItemId: string,
    public featureId: string,
    public name: string
  ) {
    super(id, meta);
  }

  get type(): FeatureAuthorizationType {
    return this.featureId === baseFeatureId
      ? FeatureAuthorizationType.Base
      : FeatureAuthorizationType.PageFeature;
  }

  static createFrom(feature: PageFeature, navigationItem: NavigationItemEntity): FeatureAuthorizationEntity {
    return new FeatureAuthorizationEntity('', {}, navigationItem.id, feature.featureId, feature.name);
  }
}
